/* Vorher-Nachher-Bereich der Produktseite (04.11.2026). Die ersten Karten stehen im HTML (snippets/vorher-nachher-schieber.liquid); dieses Skript ruft nur eines ab:
 * am Ende der Reihe die Galerieseite des Shops (gleiche Herkunft, nie new-era.cloud), um weitere Projekte nachzuladen.
 *
 * Weitere Projekte: Ist die Reihe im Bild UND ihr Ende in der Reihe sichtbar (zwei IntersectionObserver; beim Laden der Seite wird nichts abgerufen), laedt das Skript einmal die Galerieseite, liest deren Daten (vg-daten, vg-texte: dieselbe Auswahl wie die Seite,
 * keine zweite) und haengt je Schritt 12 Karten an: zuerst die weiteren Projekte dieses Produkts, danach die uebrigen; nur Paare, keine schon gezeigten. Scheitert das Laden,
 * endet die Reihe still (kein Fehler, kein Dauerladen). Eine neue Karte ist eine Kopie der ersten Karte; ihr Aufbau steht nur im Snippet.
 *
 * Grossansicht (dialog, modal: der Fokus bleibt darin): die Detailansicht der Galerieseite (pages/vorher-nachher-projekte.html, zeigeGross), Schritt fuer Schritt nachgebaut.
 * Hochkant (Handy): ein Bild fuellt den Schirm, unten die Leiste und der Umschalter „Vorher | Nachher“; Tippen aufs Bild, der Umschalter oder Wischen wechseln das Bild, es gibt
 * keine Pfeile (wie die Galerie: ein Tippen aufs Bild oder seinen unscharfen Hintergrund wechselt das Bild; zum naechsten Projekt geht es dort hochkant nicht, man schliesst und tippt die Karte). Quer (Rechner): beide Bilder gross nebeneinander mit ihren Marken, runde Pfeile (und Pfeiltasten, Wischen) gehen zum naechsten und vorigen Projekt.
 * Oben links Pfeil zurueck, Initiale und Vorname; unten die Leiste mit Produkt, Farbton und Knopf (?ral= bei belegtem Ton). Schliessen: Pfeil, Esc, Klick daneben oder die
 * Zurueck-Taste des Geraets (Verlaufseintrag wie die Galerie). */
(function () {
  'use strict'
  var JE = 12               // Projekte je Nachladeschritt
  var FUELLEN_BIS = 0.42    // hochkant: das Bild deckt den Schirm, solange dabei hoechstens so viel davon wegfaellt (wie die Galerie)
  var KREISE = ['#7b98b3', '#b58a6c', '#7fa17a', '#a582a6', '#c07e6c', '#6c9a95']

  function url(u, breite) { return u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=' + breite }
  function ohneQuery(u) { return String(u || '').split('?')[0] }
  // Die Karten-Daten aus der Galerieseite (vg-daten, vg-texte): zuerst die Projekte dieses Produkts (handle), dann die uebrigen; nur Paare, keine schon gezeigten (gezeigt: Nachher-Adresse ohne Query → true).
  // Rein. Sie rechnet Art, Farbton („ähnlich“ bei Schaetzung) und Adresse (?ral=) aus den Seitendaten; die ersten Karten kommen aus dem Metafeld (src/modules/vorher-nachher/produkt-paare.js).
  // Beide Wege muessen dasselbe sagen: tests/vorher-nachher-schieber.test.js vergleicht sie an echten Paaren und wird bei Abweichung rot.
  function kartenDatenAusGalerie(html, sprache, rootAttr, handle, gezeigt) {
    var m = html.match(/<script type="application\/json" id="vg-daten">([\s\S]*?)<\/script>/)
    var t = html.match(/<script type="application\/json" id="vg-texte">([\s\S]*?)<\/script>/)
    if (!m || !t) throw new Error('Galerieseite ohne Daten')
    var daten = JSON.parse(m[1])
    var alleTexte = JSON.parse(t[1])
    var T = alleTexte[sprache] || alleTexte.de || {}
    var root = (rootAttr || '/').replace(/\/?$/, '/')
    var eigene = []
    var andere = []
    for (var i = 0; i < daten.length; i++) {
      var p = daten[i]
      if (!p || p.a !== 'p' || !p.b || p.b.length !== 2 || (gezeigt && gezeigt[ohneQuery(p.b[1])])) continue
      var art = p.o === 'anderes' ? '' : ((T.objekte && T.objekte[p.o]) || p.on || '')
      var d = {
        v: p.b[0], n: p.b[1], art: art, produkt: p.pn || '', name: p.n || '', e: !!p.e,
        farbe: p.f ? (p.e ? (T.aehnlich || 'ähnlich') + ' ' : '') + p.f : '',
        href: p.u ? root + 'products/' + encodeURIComponent(p.u) + (p.c && !p.e ? '?ral=' + encodeURIComponent(p.c) : '') : ''
      }
      ;(p.u && p.u === handle ? eigene : andere).push(d)
    }
    return eigene.concat(andere)
  }
  window.flVnsKartenDaten = kartenDatenAusGalerie   // fuer den Vergleichstest; sonst nirgends gerufen

  function hochkant() {
    try { if (window.matchMedia) return window.matchMedia('(max-aspect-ratio: 1/1)').matches } catch (e) { /* weiter */ }
    return (window.innerHeight || 0) >= (window.innerWidth || 0)
  }

  function start(wurzel) {
    var reihe = wurzel.querySelector('[data-vns-reihe]')
    var ende = wurzel.querySelector('[data-vns-ende]')
    var dlg = wurzel.querySelector('[data-vns-licht]')
    if (!reihe || !dlg || typeof dlg.showModal !== 'function') return
    var bilder = dlg.querySelector('[data-vns-bilder]')
    var wahl = dlg.querySelector('[data-vns-wahl]')
    var zurueckKnopf = dlg.querySelector('[data-vns-zurueck]')
    var weiterKnopf = dlg.querySelector('[data-vns-weiter]')
    var knopf = dlg.querySelector('[data-vns-knopf]')
    var sprache = wurzel.getAttribute('data-sprache') || 'de'
    var aktiv = 0
    var seite = 0            // hochkant: 0 Vorher, 1 Nachher (wie die Galerie beginnt es mit Vorher)
    var geoeffnet = null     // die Karte, von der aus geoeffnet wurde (dorthin kehrt der Fokus zurueck)
    var imVerlauf = false
    var zuTakt = 0
    var wischX = null
    var zuletztHoch = null   // Lage, in der die Grossansicht zuletzt gebaut wurde (resize baut nur bei Wechsel hochkant/quer neu)

    wurzel.classList.add('is-js')

    function karten() { return Array.prototype.slice.call(reihe.querySelectorAll('[data-vns-karte]')) }
    function txt(k) { return dlg.getAttribute('data-txt-' + k) || '' }

    // ---- Weitere Projekte nachladen ----
    var vorlage = reihe.querySelector('[data-vns-karte]')   // die erste Karte: ihr Aufbau ist die Vorlage
    var zustand = { lauf: null, fertig: false, queue: null }

    function karteBauen(d) {
      var k = vorlage.cloneNode(true)
      var alt = d.art ? ': ' + d.art : ''
      k.setAttribute('data-v', d.v)
      k.setAttribute('data-n', d.n)
      k.setAttribute('data-href', d.href || '')
      if (d.e) k.setAttribute('data-e', '1'); else k.removeAttribute('data-e')
      k.setAttribute('data-farbe', d.farbe)
      k.setAttribute('data-art', d.art)
      k.setAttribute('data-produkt', d.produkt)
      k.setAttribute('data-name', d.name)
      var nachher = k.querySelector('.fl-vns__nachher')
      var vorher = k.querySelector('.fl-vns__klein img')
      nachher.setAttribute('loading', 'lazy')
      vorher.setAttribute('loading', 'lazy')
      nachher.src = url(d.n, 450)
      nachher.setAttribute('srcset', [300, 450, 600].map(function (b) { return url(d.n, b) + ' ' + b + 'w' }).join(', '))
      nachher.alt = nachher.alt.split(':')[0] + alt
      vorher.src = url(d.v, 240)
      vorher.setAttribute('srcset', [120, 240].map(function (b) { return url(d.v, b) + ' ' + b + 'w' }).join(', '))
      vorher.alt = vorher.alt.split(':')[0] + alt
      var artEl = k.querySelector('.fl-vns__art')
      if (d.art) {
        if (!artEl) { artEl = document.createElement('span'); artEl.className = 'fl-vns__art'; k.insertBefore(artEl, k.querySelector('.fl-vns__zeile')) }
        artEl.textContent = d.art
      } else if (artEl) artEl.parentNode.removeChild(artEl)
      k.querySelector('.fl-vns__zeile').textContent = (d.produkt ? d.produkt + ' · ' : '') + d.farbe
      return k
    }

    // Die Daten der Galerieseite in Karten-Daten verwandeln; zuerst dieses Produkt, dann die uebrigen (die Rechnung steht oben: kartenDatenAusGalerie)
    function queueBauen(html) {
      var gezeigt = {}
      karten().forEach(function (k) { gezeigt[ohneQuery(k.getAttribute('data-n'))] = true })
      return kartenDatenAusGalerie(html, sprache, wurzel.getAttribute('data-root'), wurzel.getAttribute('data-handle'), gezeigt)
    }

    // Ein Lauf zur Zeit; wer waehrend des Laufs fragt, bekommt dasselbe Ergebnis (zustand.lauf) und kann darauf warten.
    function nachladen() {
      if (zustand.fertig) return Promise.resolve()
      if (zustand.lauf) return zustand.lauf
      if (ende) ende.classList.add('is-laedt')
      var geholt = zustand.queue ? Promise.resolve() : window.fetch(wurzel.getAttribute('data-galerie'), { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status)
        return r.text()
      }).then(function (html) { zustand.queue = queueBauen(html) })
      zustand.lauf = geholt.then(function () {
        zustand.queue.splice(0, JE).forEach(function (d) { reihe.insertBefore(karteBauen(d), ende) })
        if (!zustand.queue.length) zustand.fertig = true
      }).catch(function () { zustand.fertig = true })   // am Ende kein Fehler: die Reihe hoert still auf
        .then(function () {
          zustand.lauf = null
          if (ende) ende.classList.remove('is-laedt')
          if (zustand.fertig && ende && ende.parentNode) { beobachterAus(); ende.parentNode.removeChild(ende); ende = null }
          // Steht das Ende nach dem Anhaengen noch im Bild (die Reihe ist noch nicht voll), meldet der Beobachter es nicht von selbst noch einmal.
          else if (ende && endeBeobachter) { endeBeobachter.unobserve(ende); endeBeobachter.observe(ende) }
          if (dlg.open) pfeile()   // ist die Reihe zu Ende, verschwindet der Weiter-Pfeil
        })
      return zustand.lauf
    }

    // Abgerufen wird nichts beim Laden der Seite (die Galerieseite ist rund 0,5 MB): erst wenn die Reihe im Bild ist UND ihr Ende in der Reihe sichtbar wird.
    var imBild = false
    var endeSichtbar = false
    var reiheBeobachter = null
    var endeBeobachter = null
    function pruefeNachladen() { if (imBild && endeSichtbar) nachladen() }
    function beobachterAus() { if (reiheBeobachter) reiheBeobachter.disconnect(); if (endeBeobachter) endeBeobachter.disconnect() }
    if (ende && 'IntersectionObserver' in window && window.fetch) {
      reiheBeobachter = new IntersectionObserver(function (e) { imBild = e[e.length - 1].isIntersecting; pruefeNachladen() }, { rootMargin: '0px 0px 100px 0px' })
      endeBeobachter = new IntersectionObserver(function (e) { endeSichtbar = e[e.length - 1].isIntersecting; pruefeNachladen() }, { root: reihe, rootMargin: '0px 400px 0px 0px' })
      reiheBeobachter.observe(reihe)
      endeBeobachter.observe(ende)
    } else if (ende) ende.parentNode.removeChild(ende)   // ohne Beobachter bleibt es bei den ersten Karten

    // ---- Grossansicht (nach zeigeGross der Galerieseite) ----
    function einzeln() { return hochkant() }

    // Hochkant: deckt das Bild den Schirm mit hoechstens FUELLEN_BIS Verlust, fuellt es (cover), sonst steht es ganz (contain) vor dem unscharfen Hintergrund.
    function fuellen(img) {
      var w = img.naturalWidth
      var h = img.naturalHeight
      var W = bilder.clientWidth
      var H = bilder.clientHeight
      if (!w || !h || !W || !H) return
      var b = w / h
      var s = W / H
      if ((b > s ? 1 - s / b : 1 - b / s) <= FUELLEN_BIS) img.className = 'fl-vns__vorn fl-vns__fuellt'
    }

    function person(name) {
      var feld = dlg.querySelector('[data-vns-person]')
      feld.hidden = !name
      if (!name) return
      dlg.querySelector('[data-vns-name]').textContent = name
      var ini = dlg.querySelector('[data-vns-initiale]')
      ini.textContent = name.charAt(0).toUpperCase()
      var s = 0
      for (var i = 0; i < name.length; i++) s = (s * 31 + name.charCodeAt(i)) % 9973
      ini.style.backgroundColor = KREISE[s % KREISE.length]
    }

    // Zeigt Projekt i; hochkant das Bild s (0 Vorher, 1 Nachher), quer beide nebeneinander
    function zeige(i, s) {
      var alle = karten()
      if (i < 0 || i >= alle.length) return
      var d = alle[i].dataset
      var art = d.art || ''
      var alt = art ? ': ' + art : ''
      var hoch = einzeln()
      aktiv = i
      zuletztHoch = hoch
      seite = hoch && s === 1 ? 1 : 0
      var zeigen = hoch ? [seite] : [0, 1]
      while (bilder.firstChild) bilder.removeChild(bilder.firstChild)
      bilder.className = 'fl-vns__bilder' + (hoch ? '' : ' fl-vns__paar')
      wahl.hidden = !hoch
      var knoepfe = wahl.querySelectorAll('button')
      for (var w = 0; w < knoepfe.length; w++) knoepfe[w].setAttribute('aria-pressed', Number(knoepfe[w].getAttribute('data-seite')) === seite ? 'true' : 'false')
      for (var z = 0; z < zeigen.length; z++) {
        var k = zeigen[z]
        var wort = k ? 'nachher' : 'vorher'
        // Ein Bild ohne srcset: Mit Breitenangaben rechnet der Browser die Groesse aus der angefragten Breite und zeigt ein kleineres Original zu klein an (Galerie, gemessen 27.09.2026)
        var quelle = url(k ? d.n : d.v, 1000)
        var f = document.createElement('figure')
        f.className = 'fl-vns__bild'
        if (hoch) {
          var hinter = document.createElement('img')
          hinter.className = 'fl-vns__hinter'
          hinter.src = quelle
          hinter.alt = ''
          hinter.setAttribute('aria-hidden', 'true')
          f.appendChild(hinter)
        }
        var img = document.createElement('img')
        img.className = 'fl-vns__vorn'
        img.src = quelle
        img.alt = dlg.getAttribute('data-alt-' + wort) + alt
        img.setAttribute('decoding', 'async')
        if (hoch) {
          if (img.complete) fuellen(img)
          else img.addEventListener('load', function () { fuellen(this) })
        }
        f.appendChild(img)
        if (!hoch) {
          var m = document.createElement('span')
          m.className = 'fl-vns__marke' + (k === 1 ? ' fl-vns__marke--nachher' : '')
          m.textContent = txt(wort)
          f.appendChild(m)
        }
        bilder.appendChild(f)
      }
      // Die andere Seite schon laden, damit der Wechsel sofort steht.
      if (hoch) { try { new Image().src = url(seite ? d.v : d.n, 1000) } catch (e) { /* ohne Vorladen */ } }
      person(d.name || '')
      dlg.querySelector('[data-vns-produkt]').textContent = d.produkt || art || ''
      dlg.querySelector('[data-vns-farbe]').textContent = d.farbe || ''
      // Belegter Ton: „Diesen Farbton wählen ›“ mit ?ral=; ohne belegten Ton „Zum Produkt ›“ (die Adresse steht fertig an der Karte)
      knopf.textContent = d.e ? txt('produkt') : txt('waehlen')
      knopf.hidden = !d.href
      if (d.href) knopf.href = d.href
      pfeile()
    }
    // Die runden Pfeile (quer): zurueck nicht am ersten Projekt, weiter nicht am letzten, wenn nichts mehr nachkommt.
    function pfeile() {
      var hoch = einzeln()
      zurueckKnopf.hidden = hoch || aktiv === 0
      weiterKnopf.hidden = hoch || (aktiv >= karten().length - 1 && zustand.fertig)
    }

    function oeffnen(i) {
      geoeffnet = karten()[i]
      dlg.showModal()
      document.documentElement.style.overflow = 'hidden'
      zeige(i, 0)
      try { if (window.history && history.pushState) { history.pushState({ vnsGross: 1 }, ''); imVerlauf = true } } catch (e) { /* ohne Verlaufseintrag */ }
    }
    function schliesse() {
      window.clearTimeout(zuTakt)
      if (dlg.open) dlg.close()
    }
    // Schliessen ueber den Verlauf, damit der eigene Eintrag wieder verschwindet (wie die Galerie); kommt kein popstate, schliesst der Rueckfall.
    function zu() {
      if (imVerlauf) {
        imVerlauf = false
        try { history.back(); zuTakt = window.setTimeout(schliesse, 400); return } catch (e) { /* weiter */ }
      }
      schliesse()
    }
    function projekt(r) {
      var n = aktiv + r
      if (n >= 0 && n < karten().length) { zeige(n, 0); return }
      // Am Ende der geladenen Karten: auf das Nachladen warten (auch wenn es schon laeuft), dann weiter; kommt nichts nach, verschwindet der Pfeil
      if (r > 0 && !zustand.fertig) {
        var von = aktiv
        nachladen().then(function () {
          if (!dlg.open || aktiv !== von) return
          if (aktiv + 1 < karten().length) zeige(aktiv + 1, 0); else pfeile()
        })
      }
    }
    // Hochkant nur zwischen Vorher und Nachher, quer zum naechsten oder vorigen Projekt (wie die Galerie).
    function schritt(r) {
      if (einzeln()) {
        if (r > 0 ? seite === 0 : seite === 1) zeige(aktiv, r > 0 ? 1 : 0)
        return
      }
      projekt(r)
    }

    reihe.addEventListener('click', function (e) {
      var k = e.target && e.target.closest ? e.target.closest('[data-vns-karte]') : null
      if (k) oeffnen(karten().indexOf(k))
    })
    dlg.querySelector('[data-vns-zu]').addEventListener('click', zu)
    zurueckKnopf.addEventListener('click', function () { projekt(-1) })
    weiterKnopf.addEventListener('click', function () { projekt(1) })
    wahl.addEventListener('click', function (e) {
      var s = e.target && e.target.getAttribute && e.target.getAttribute('data-seite')
      if (s !== null && s !== undefined) zeige(aktiv, Number(s))
    })
    dlg.addEventListener('click', function (e) {
      // Hochkant (wie die Galerie): Tippen auf das Bild, auch auf den unscharfen Hintergrund dahinter, wechselt zwischen Vorher und Nachher; zu geht es mit dem Pfeil.
      // Quer schliesst ein Klick neben die Bilder.
      var t = e.target
      if (einzeln() && t && t !== bilder && bilder.contains(t)) return zeige(aktiv, 1 - seite)
      if (t === dlg || t === bilder || t === dlg.querySelector('[data-vns-innen]')) return zu()
    })
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); zu() })   // Esc
    dlg.addEventListener('close', function () {
      document.documentElement.style.overflow = ''
      while (bilder.firstChild) bilder.removeChild(bilder.firstChild)
      if (geoeffnet) geoeffnet.focus()
    })
    window.addEventListener('popstate', function () { imVerlauf = false; schliesse() })
    document.addEventListener('keydown', function (e) {
      if (!dlg.open) return
      if (e.key === 'ArrowLeft') schritt(-1)
      else if (e.key === 'ArrowRight') schritt(1)
    })
    // Wischen: nach links vor, nach rechts zurueck (hochkant Vorher/Nachher, quer Projekt)
    dlg.addEventListener('touchstart', function (e) { wischX = e.touches && e.touches.length === 1 ? e.touches[0].clientX : null }, { passive: true })
    dlg.addEventListener('touchend', function (e) {
      if (wischX === null || !e.changedTouches || !e.changedTouches.length) return
      var dx = e.changedTouches[0].clientX - wischX
      wischX = null
      if (Math.abs(dx) > 50) schritt(dx < 0 ? 1 : -1)
    }, { passive: true })
    var drehung = 0
    window.addEventListener('resize', function () {
      if (!dlg.open) return
      window.clearTimeout(drehung)
      drehung = window.setTimeout(function () { if (dlg.open && hochkant() !== zuletztHoch) zeige(aktiv, seite) }, 150)   // nur beim Wechsel hochkant/quer (die Adressleiste des Handys aendert nur die Hoehe)
    })
  }

  function los() { Array.prototype.forEach.call(document.querySelectorAll('[data-fl-vns]'), start) }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', los); else los()
})()
